/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ extension: NonNullable<unknown> }} Translation_Import_Unsupported_Format_ToastInputs */

const en_translation_import_unsupported_format_toast = /** @type {(inputs: Translation_Import_Unsupported_Format_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The file format .${i?.extension} is not supported.`)
};

const fr_translation_import_unsupported_format_toast = /** @type {(inputs: Translation_Import_Unsupported_Format_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Le format de fichier .${i?.extension} n'est pas pris en charge.`)
};

const de_translation_import_unsupported_format_toast = /** @type {(inputs: Translation_Import_Unsupported_Format_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Das Dateiformat .${i?.extension} wird nicht unterstützt.`)
};

const it_translation_import_unsupported_format_toast = /** @type {(inputs: Translation_Import_Unsupported_Format_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il formato file .${i?.extension} non è supportato.`)
};

const ru_translation_import_unsupported_format_toast = /** @type {(inputs: Translation_Import_Unsupported_Format_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Формат файла .${i?.extension} не поддерживается.`)
};

const es_translation_import_unsupported_format_toast = /** @type {(inputs: Translation_Import_Unsupported_Format_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El formato de archivo .${i?.extension} no es compatible.`)
};

const zh_cn2_translation_import_unsupported_format_toast = /** @type {(inputs: Translation_Import_Unsupported_Format_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`不支持 .${i?.extension} 文件格式。`)
};

const ja_translation_import_unsupported_format_toast = /** @type {(inputs: Translation_Import_Unsupported_Format_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ファイル形式「.${i?.extension}」はサポートされていません。`)
};

const hi_translation_import_unsupported_format_toast = /** @type {(inputs: Translation_Import_Unsupported_Format_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`.${i?.extension} फ़ाइल प्रारूप समर्थित नहीं है।`)
};

const pt_pt2_translation_import_unsupported_format_toast = /** @type {(inputs: Translation_Import_Unsupported_Format_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O formato de arquivo .${i?.extension} não é suportado.`)
};

/**
* | output |
* | --- |
* | "The file format .{extension} is not supported." |
*
* @param {Translation_Import_Unsupported_Format_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_import_unsupported_format_toast = /** @type {((inputs: Translation_Import_Unsupported_Format_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Import_Unsupported_Format_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_translation_import_unsupported_format_toast(inputs)
	if (locale === "de") return de_translation_import_unsupported_format_toast(inputs)
	if (locale === "it") return it_translation_import_unsupported_format_toast(inputs)
	if (locale === "ru") return ru_translation_import_unsupported_format_toast(inputs)
	if (locale === "es") return es_translation_import_unsupported_format_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_translation_import_unsupported_format_toast(inputs)
	if (locale === "ja") return ja_translation_import_unsupported_format_toast(inputs)
	if (locale === "hi") return hi_translation_import_unsupported_format_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_translation_import_unsupported_format_toast(inputs)
	return en_translation_import_unsupported_format_toast(inputs)
});